import { render } from "./CometChatSenderTextMessageBubble.vue?vue&type=template&id=1a144a30"
import script from "./CometChatSenderTextMessageBubble.vue?vue&type=script&lang=js"
export * from "./CometChatSenderTextMessageBubble.vue?vue&type=script&lang=js"

import "./CometChatSenderTextMessageBubble.vue?vue&type=style&index=0&id=1a144a30&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__